import { React, useEffect, useState, useContext } from 'react'
import { MyContextProvider } from "../../../../App";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {handleUserLevelAccessPermissions, changeDateFormat,
    getFormattedDate,formatDate,isEndDateGreater,validateRoles
} from '../../../../Custom/Custom'
import { GlobalLoading, showLoading } from 'react-global-loading';
import { jwtDecode } from 'jwt-decode';
import titlesData from '../../../../titles.json';
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import { API_URL } from '../../../../Constant';
import messages from '../.././../../assets/Messages.json';
import { ToastContainer, toast } from 'react-toastify';
import { districtPriceReprt } from '../../../../Custom/PriceWagesIndiceSystemReport/ExportExcel'
import priceTitle from '../../../../price.json';

function DistrictPriceReport() {
    const token = useContext(MyContextProvider).token;
    const decode_token = jwtDecode(token);
    // const [isDivision, setIsDivision] = useState(false);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const today = new Date();

    const [buttonAccess, setButtonAccess] = useState(false);
    const storedLanguage = localStorage.getItem('language');
    const navigate = useNavigate();
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };

    useEffect(() => {


        const userRole = async () => {
            showLoading(true)
            try {
              const role = await validateRoles(jwtDecode(token));
              if (!role) {
                alert("You are not an authorized user for Pricing Report.");
                navigate("/dashboard");
              } 
            } catch (error) {
              console.log(error);
            }finally {
              showLoading(false)
            }
          }

        const level = handleUserLevelAccessPermissions(decode_token);
        setButtonAccess(level)


        userRole();


    }, []);




    //handle excel sheet ***************
const handleGenerateExcel = () => {
    if (!startDate || !endDate) {
        toast.error('Please select the date range', messages.COLOR_RED);
        return;
    }
    if(!isEndDateGreater(startDate,endDate)){
        toast.error(messages.DATE_BETWEEN_MESSAGE, messages.COLOR_RED);
        return;
      }
    

        showLoading(true);
        let sDate= getFormattedDate(startDate);
        let eDate=getFormattedDate(endDate);
        const payload = {
            fromDate:sDate,
            toDate:eDate
        };

    // POST request to API
    axios
        .post(`${API_URL}api/price/getRuralCurrentPrice`, payload, config)
        .then((response) => {
           let allData=response.data;
            if(allData.status){
                downloadReport(allData.data[0].GroupCodes,sDate,eDate)
            }else{
                 toast.error('Data is not Found', messages.COLOR_RED);
           }
        })
        .catch((error) => {
            console.error('API Error:', error);
            showLoading(false);
        }).finally(()=>{
            showLoading(false);
        });
    };


 const formatGrossValue = (value) => {
    if (value === 0) return '0.00';
    if (value === "NaN" ) return '';
    if (value === '' || value === null) return '0.00';
    return Number(value).toFixed(2);
    };



const downloadReport=(allData,sDate,eDate)=>{

    const transformedData = allData.map(item => [
       
            item.DISTRICT_CODE,
            formatDate(item.mondate),
            item.DISTRICT_UNIT,
            formatGrossValue(item.CURRENT_PRICE_WHEAT),
            formatGrossValue(item.CURRENT_PRICE_RICE_ARWA),
            formatGrossValue(item.CURRENT_PRICE_GRAM_WHOLE),
            formatGrossValue(item.CURRENT_PRICE_MAIZE),
            formatGrossValue(item.CURRENT_PRICE_BAJRA),
            formatGrossValue(item.CURRENT_PRICE_ARHAR_DAL),
            formatGrossValue(item.CURRENT_PRICE_URD_DAL),
            formatGrossValue(item.CURRENT_PRICE_MASUR_DAL),
            formatGrossValue(item.CURRENT_PRICE_PEA_DAL),
            formatGrossValue(item.CURRENT_PRICE_MOONG_DAL),
            formatGrossValue(item.CURRENT_PRICE_GRAM_DAL),
            formatGrossValue(item.CURRENT_PRICE_MILK),
            formatGrossValue(item.CURRENT_PRICE_GHEE),
            formatGrossValue(item.CURRENT_PRICE_MUSTARD_OIL),
            formatGrossValue(item.CURRENT_PRICE_VANASPATI_GHEE),
            formatGrossValue(item.CURRENT_PRICE_GOAT_MEAT),
            formatGrossValue(item.CURRENT_PRICE_FISH_ROHU),
            formatGrossValue(item.CURRENT_PRICE_EGGS),
            formatGrossValue(item.CURRENT_PRICE_POTATO),
            formatGrossValue(item.CURRENT_PRICE_TOMATO),
            formatGrossValue(item.CURRENT_PRICE_ONION),
            formatGrossValue(item.CURRENT_PRICE_BRINJAL),
            formatGrossValue(item.CURRENT_PRICE_CHILLIS),
            formatGrossValue(item.CURRENT_PRICE_APPLE),
            formatGrossValue(item.CURRENT_PRICE_BANANA),
            formatGrossValue(item.CURRENT_PRICE_MANGO),
            formatGrossValue(item.CURRENT_PRICE_GROUNDNUT),
            formatGrossValue(item['CURRENT_PRICE_COCONUT_(COPRA)']),
            formatGrossValue(item.CURRENT_PRICE_SUGAR),
            formatGrossValue(item.CURRENT_PRICE_GUR),
            formatGrossValue(item['CURRENT_PRICE_CORRIANDER_(WHOLE)']),
            formatGrossValue(item.CURRENT_PRICE_CHILLIES__WHOLE),
            formatGrossValue(item.CURRENT_PRICE_TURMERIC_WHOLE),
            formatGrossValue(item.CURRENT_PRICE_SALT),
            formatGrossValue(item.CURRENT_PRICE_GARAM_MASALA),
            formatGrossValue(item.CURRENT_PRICE_PREPARED_SWEETS),
            formatGrossValue(item.CURRENT_PRICE_BISCUITS),
            formatGrossValue(item.CURRENT_PRICE_NAMKEEN),
            formatGrossValue(item.CURRENT_PRICE_TEA_LEAF),
            formatGrossValue(item.CURRENT_PRICE_TEA_CUPS),
            formatGrossValue(item.CURRENT_PRICE_COLD_DRINK),
            formatGrossValue(item.CURRENT_PRICE_AVERAGE_OF_PAN_LEAF_SADA_AND_SUPARI),
            formatGrossValue(item.CURRENT_PRICE_BIDI),
            formatGrossValue(item.CURRENT_PRICE_CIGRATTE),
            formatGrossValue(item.CURRENT_PRICE_TOBACCO_CHEWING_LEAF),
            formatGrossValue(item.CURRENT_PRICE_COUNTRY_LIQUOR),
            formatGrossValue(item.CURRENT_PRICE_ELECTRICITY),
            formatGrossValue(item.CURRENT_PRICE_LPG),
            formatGrossValue(item.CURRENT_PRICE_FIREWOODS),
            formatGrossValue(item.CURRENT_PRICE_DUNGCAKE),
            formatGrossValue(item.CURRENT_PRICE_KEROSENE),
            formatGrossValue(item.CURRENT_PRICE_MATCH_BOX),
            formatGrossValue(item.CURRENT_PRICE_CANDLE),
            formatGrossValue(item.CURRENT_PRICE_AVERAGE_OF_RAJ_AND_UNSKILLED_LABOUR),
            formatGrossValue(item.CURRENT_PRICE_CLOTH_SHIRT),
            formatGrossValue(item.CURRENT_PRICE_SARI),
            formatGrossValue(item.CURRENT_PRICE_DHOTI_MARDANI),
            formatGrossValue(item.CURRENT_PRICE_HOSIERY_BANIYAN),
            formatGrossValue(item.CURRENT_PRICE_BEDSHEET),
            formatGrossValue(item.CURRENT_PRICE_LEATHER_SHOES),
            formatGrossValue(item['CURRENT_PRICE_LEATHER_SANDALS_(LADIES)']),
            formatGrossValue(item.CURRENT_PRICE_RUBBER_OR_PVC_FOOTWEAR_CHAPPAL),
            formatGrossValue(item.CURRENT_PRICE_TUTIONFEES),
            formatGrossValue(item.CURRENT_PRICE_REGISTER),
            formatGrossValue(item.CURRENT_PRICE_NEWSPAPERS),
            formatGrossValue(item.CURRENT_PRICE_CROCIN),
            formatGrossValue(item.CURRENT_PRICE_ATIN_50),
            formatGrossValue(item.CURRENT_PRICE_DAYNIL),
            formatGrossValue(item.CURRENT_PRICE_COUGH_SYRUP),
            formatGrossValue(item.CURRENT_PRICE_DOCTORS_FEES__AT_CLINIC),
            formatGrossValue(item.CURRENT_PRICE_BLOOD_TEST),
            formatGrossValue(item.CURRENT_PRICE_CINEMA_TICKET),
            formatGrossValue(item['CURRENT_PRICE_RADIO_(2_BAND)']),
            formatGrossValue(item.CURRENT_PRICE_BATHING__SOAP),
            formatGrossValue(item.CURRENT_PRICE_HAIR_OIL),
            formatGrossValue(item.CURRENT_PRICE_TOOTHPASTE),
            formatGrossValue(item.CURRENT_PRICE_TELCOM_POWDER),
            formatGrossValue(item.CURRENT_PRICE_SHAVING_BLADES),
            formatGrossValue(item.CURRENT_PRICE_AGARBATI),
            formatGrossValue(item.CURRENT_PRICE_TORCH),
            formatGrossValue(item['CURRENT_PRICE_BATTRY_(DRY_CELL)']),
            formatGrossValue(item.CURRENT_PRICE_WASHING_SHOP),
            formatGrossValue(item.CURRENT_PRICE_UNSKILLED_LABOUR),
            formatGrossValue(item.CURRENT_PRICE_TAILOR),
            formatGrossValue(item.CURRENT_PRICE_BARBER),
            formatGrossValue(item.CURRENT_PRICE_GRINDING),
            formatGrossValue(item.CURRENT_PRICE_SINGLE_BED),
            formatGrossValue(item.CURRENT_PRICE_THALI),
            formatGrossValue(item.CURRENT_PRICE_CEILLING_FAN),
            formatGrossValue(item.CURRENT_PRICE_MOBILE_PHONE_OR_HANDSET),
            formatGrossValue(item.CURRENT_PRICE_REGISTERD_LETTER),
            formatGrossValue(item['CURRENT_PRICE_TELEPHONE_CHARGES_(BSNL)']),
            formatGrossValue(item.CURRENT_PRICE_PETROL),
            formatGrossValue(item.CURRENT_PRICE_RAILWAY_FARE),
            formatGrossValue(item.CURRENT_PRICE_BUS_FARE),
            formatGrossValue(item.CURRENT_PRICE_CYCLE),
            formatGrossValue(item.CURRENT_PRICE_MOTOR_CYCLE),
            formatGrossValue(item.CURRENT_PRICE_GOLD),
            formatGrossValue(item.CURRENT_PRICE_SILVER)

    ]);



    const excelObjectData = {
        fileName:"RuralDistrictPriceReport",
        fileType:'xls',
        sheetName: 'PRICurrentPrice',
        firstRowMergeCells: "A1:CX1",
        firstRowExportDate:  changeDateFormat(new Date()),
        secondRowMergeCells: "A2:CX2",
        secondRowText: `                                                                                 Rural District Price Report (${sDate}-${eDate}) (Base Year 2011-12=100)`,
        headerEnglishColumns: [
            'Reg_Dist',
            'Month',
            ' District Unit',
            'गेहूँ',
            'चावल अरवा',
            'ग्राम पूरा',
            'मक्का',
            'बाजरे',
            'अरहर दाल',
            'उरद दाल',
            'मासुर दाल',
            'मटर दाल',
            'मूंग दाल',
            'ग्राम दाल',
            'दूध',
            'घी',
            'सरसों का तेल',
            'वानस्पति घी',
            'बकरी का मांस',
            'मछली रोहू',
            'अंडे',
            'आलू',
            'टमाटर',
            'प्याज',
            'बैंगन',
            'मिर्च',
            'सेब',
            'केला',
            'आम',
            'मूंगफली',
            'नारियल (कोपरा)',
            'चीनी',
            'गुड़',
            'धनिया (पूरे)',
            'पूरी तरह से मिर्च',
            'हल्दी होल',
            'नमक',
            'गरम मसाला',
            'तैयार मिठाई',
            'बिस्कुट',
            'नमकीन',
            'चाय पत्ती',
            'चाय कप',
            'ठंडा पेय',
            'पैन लीफ साडा और सुपरी का औसत',
            'बीड़ी',
            'सिगरेट',
            'तंबाकू चबाने वाला पत्ता',
            'दारु देसी',
            'बिजली',
            'रसोई गैस',
            'जलाऊ लकड़ी  ',
            'डंग केक',
            'मिटटी तेल',
            'मैच बॉक्स',
            'मोमबत्ती',
            'राज और अकुशल श्रम का औसत',
            'कपड़ा शर्ट',
            'साड़ी',
            'धोती मर्दानी',
            'होजरी बनीयान',
            'चादर',
            'चमड़े के जूते',
            'चमड़े के सैंडल (देवियों)',
            'रबड़ या पीवीसी जूते चप्पल',
            'ट्यूशन शुल्क',
            'रजिस्टर',
            'समाचार पत्र',
            'क्रोसिन',
            'एटिन 50',
            'दायनिल ',
            'खांसी की दवाई',
            'क्लिनिक में डॉक्टरों की फीस',
            'रक्त परीक्षण',
            'सिनेमा टिकट',
            'रेडियो (2 बैंड)',
            'स्नान साबुन',
            'केश तेल',
            'टूथपेस्ट',
            'टेलकॉम पाउडर',
            'शेविंग ब्लेड',
            'अगरबत्ती',
            'मशाल',
            'बैट्री (सूखी सेल)',
            'वॉशिंग शॉप',
            'अकुशल मजदूर',
            'दर्जी',
            'नाई',
            'पिसाई',
            'एक बिस्तर',
            'थाली',
            'सीलिंग फैन',
            'मोबाइल फोन या हैंडसेट',
            'पंजीकृत पत्र',
            'टेलीफोन शुल्क (बीएसएनएल)',
            'पेट्रोल',
            'रेलवे किराया',
            'बस किराया',
            'साइकिल',
            'मोटर साइकिल',
            'सोना',
            'चांदी'

           ],
           excelRowData:transformedData

      };

     districtPriceReprt(excelObjectData);

}


  return (
    <>     
            <ToastContainer />
            <GlobalLoading />
            <div className="container-fluid py-3">
                <div className="card mx-3 mb-3">
                    <div className="card-body pb-1">
                        <div className="row">
                            <div className="col-12">
                                <h4 className="page_heading">
                                    <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? priceTitle.hi.DISTRICT_PRICE_REPORT : priceTitle.en.DISTRICT_PRICE_REPORT }} />
                                </h4>
                            </div>
                        </div>
                        <div className="row align-items-end">
                            <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12 mb-3">
                                <label className="form-label">From Date</label>
                                <DatePicker
                                    className="form-control calendar_icon"
                                    wrapperClassName="w-100 d-block"
                                    selected={startDate}
                                    onChange={(e) => { setStartDate(e) }}
                                    dateFormat="MMM yyyy"
                                    showMonthYearPicker
                                    placeholderText="Select month"
                                    maxDate={today}
                                />
                            </div>

                            <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12 mb-3">
                                <label className="form-label">To Date</label>
                                <DatePicker
                                    className="form-control calendar_icon"
                                    wrapperClassName="w-100 d-block"
                                    selected={endDate}
                                    onChange={(e) => { setEndDate(e) }}
                                    dateFormat="MMM yyyy"
                                    showMonthYearPicker
                                    placeholderText="Select month"
                                    maxDate={today}
                                />
                            </div>

                            <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12 mb-3">
                                <button onClick={handleGenerateExcel} className="btn btn_orange">Get Report</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
  )
}

export default DistrictPriceReport